import {
  Card,
  CardHeader,
  Row,
  Table,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
  Pagination,
  PaginationItem,
  PaginationLink
} from "reactstrap";
import React from "react";
import PropTypes from "prop-types";
import securityConstant from "../../../util/securityConstant";
import { TaskPermissions, UsersPermissions } from "../../../services/permissions";
import formatFrontendDate from "../util/formatFrontendDate";
import utilService from "../../../services/utilService";

class AdminListTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      itemsPerPage: 15
    };
  }

  handlePageChange = (pageNum) => {
    this.setState({ currentPage: pageNum });
  };

  render() {
    const { adminList, adminComponentObj, cardTitle, tenantUID, userRole } = this.props;
    const { currentPage, itemsPerPage } = this.state;

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = adminList.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(adminList.length / itemsPerPage);

    return (
        <Card>
          <CardHeader className="border-0">
            <Row className="align-items-center">
              <div className="col-6">
                <h3 className="mb-0">{cardTitle}</h3>
              </div>
              <div className={"col-6 " + (tenantUID ? "" : "hidden")}>
                <Button
                    color="primary"
                    type="button"
                    size="sm"
                    onClick={(e) => {
                      e.preventDefault();
                      adminComponentObj.props.history.push(
                          `/superAdmin/tenant/crm/create/${tenantUID}`
                      );
                    }}
                    className="fa-pull-right"
                >
                  Create Tenant Admin
                </Button>
              </div>
            </Row>
          </CardHeader>
          <Table className="align-items-center table-flush" responsive>
            <thead className="thead-light">
            <tr>
              <th scope="col">#</th>
              <th scope="col"/>
              <th scope="col">Date Created</th>
              <th scope="col">Name</th>
              <th scope="col">Email Address</th>
              <th scope="col">Role</th>
              {utilService.isXgAdmin() && <th scope="col">Main Account</th>}

            </tr>
            </thead>
            <tbody className="list">
            {currentItems.map((value, index) => (
                <tr key={index}>
                  <td>{indexOfFirstItem + index + 1}</td>
                  <td className="text-right">
                    <UncontrolledDropdown>
                      <DropdownToggle color="" size="sm" className="btn-icon-only text-light">
                        <i className="fas fa-ellipsis-v"/>
                      </DropdownToggle>
                      <DropdownMenu className="dropdown-menu-arrow" right container="body">
                        <DropdownItem
                            style={{display: UsersPermissions.read()}}
                            onClick={(e) => {
                              e.preventDefault();
                              userRole === securityConstant.ROLE_ADMIN
                                  ? adminComponentObj.props.history.push(
                                      `/crm/show/${value.uniqueId}`
                                  )
                                  : adminComponentObj.props.history.push(
                                      `/superadmin/tenant/admin/show/${value.uniqueId}`
                                  );
                            }}
                        >
                          Details
                        </DropdownItem>
                        <DropdownItem
                            style={{display: UsersPermissions.update()}}
                            onClick={(e) => {
                              e.preventDefault();
                              adminComponentObj.props.history.push(
                                  `/crm/edit/${value.uniqueId}`
                              );
                            }}
                        >
                          Edit
                        </DropdownItem>
                        <DropdownItem
                            style={{display: UsersPermissions.delete()}}
                            onClick={(e) => {
                              e.preventDefault();
                              adminComponentObj.confirmDeleteAlert(`${value.uniqueId}`);
                            }}
                        >
                          Delete
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </td>
                  <td>{formatFrontendDate(value.dateCreated)}</td>
                  <td>{value.fullName}</td>
                  <td>{value.emailAddress}</td>
                  <td>{value.role}</td>
                  {utilService.isXgAdmin() && <td>{value.tenant}</td>}

                </tr>
            ))}
            </tbody>
          </Table>

          {totalPages > 1 && (
              <nav aria-label="Page navigation">
                <Pagination className="pagination justify-content-center mt-3">
                  <PaginationItem disabled={currentPage <= 1}>
                    <PaginationLink
                        previous
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          if (currentPage > 1) this.handlePageChange(currentPage - 1);
                        }}
                    />
                  </PaginationItem>

                  {[...Array(totalPages)].map((_, i) => (
                      <PaginationItem active={i + 1 === currentPage} key={i}>
                        <PaginationLink
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              this.handlePageChange(i + 1);
                            }}
                        >
                          {i + 1}
                        </PaginationLink>
                      </PaginationItem>
                  ))}

                  <PaginationItem disabled={currentPage >= totalPages}>
                    <PaginationLink
                        next
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          if (currentPage < totalPages) this.handlePageChange(currentPage + 1);
                        }}
                    />
                  </PaginationItem>
                </Pagination>
              </nav>
          )}
        </Card>
    );
  }
}

AdminListTable.propTypes = {
  adminList: PropTypes.array.isRequired,
  adminComponentObj: PropTypes.object.isRequired,
  cardTitle: PropTypes.string.isRequired,
  userRole: PropTypes.string.isRequired,
  tenantUID: PropTypes.string
};

export default AdminListTable;